import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { SearchResultsTable } from "app/pages/sales-intelligence/common-components/search-results-table";
import { StyledScrollableTableContent } from "app/pages/sales-intelligence/common-components/search-results-table/components/styles";
import type { ContactSearchEntry } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";

export const StyledTableContentContainer = styled(StyledScrollableTableContent)`
    min-height: 0;
    overflow-y: hidden;
    border-top: 1px solid ${colorsPalettes.carbon[50]};
`;

export const StyledContactsEmptyTableContainer = styled(StyledTableContentContainer)`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    padding-bottom: 80px;
`;

export const StyledSearchResultsTable = styled(SearchResultsTable<ContactSearchEntry>)`
    .ant-table-tbody .ant-table-row {
        div.ant-table-cell {
            height: auto;
        }

        .column-overflow-visible {
            overflow: visible !important;
        }

        .visibleOnRowHover {
            display: none;
        }

        &:hover .visibleOnRowHover {
            display: flex;
        }
    }
`;
